import { useState, useEffect } from 'react';
import { fetchProjectGRActionItemsFilterConditions } from '@gp/services/grActionItems';
import { formatFilterConditions } from '../utils';
import { fetchCommonConditions } from '@gp/services/filter';
import {
  IProjectGRActionItemsFilterVO,
  IProjectGRActionItemsFilterConditionsVO,
  IProjectGRActionItemsFilterValuesConditionsVO,
} from '@gp/types/grActionItems';

export default function useGRActionsFilterConditions() {
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState<IProjectGRActionItemsFilterVO>({
    dueDate: {
      dateType: 'date',
      startDate: '',
      endDate: '',
    },
    pteam: [],
    business_owner: [],
    studio: [],
    gate_review: [],
    owner: [],
    status: [],
    stage: [],
    project_id: [],
  });
  const [conditions, setConditions] = useState<IProjectGRActionItemsFilterConditionsVO>({
    dueDate: {
      min_date: '',
      max_date: '',
    },
    pteam: [],
    business_owner: [],
    studio: [],
    gate_review: [],
    owner: [],
    status: [],
    stage: [],
    project_id: [],
  });
  const [defaultValues, setDefaultValues] = useState<IProjectGRActionItemsFilterConditionsVO>({
    dueDate: {
      min_date: '',
      max_date: '',
    },
    pteam: [],
    business_owner: [],
    studio: [],
    gate_review: [],
    owner: [],
    status: [],
    stage: [],
    project_id: [],
  });

  const [actionItemCategory, setActionItemCategory] = useState([]);

  const refreshConditions = async (): Promise<IProjectGRActionItemsFilterValuesConditionsVO> => {
    try {
      const commonCondParams = {
        pteam_bo_studio_project: { project_auth: true },
        stage: [],
        action_item_status: [],
        action_item_due: [],
        action_item_gate_review: [],
        action_item_owner: [],
        action_item_category: [],
      };

      const res = await fetchCommonConditions(commonCondParams);

      const {
        values: valuesTmp,
        conditions: conditionsTmp,
        defaultValues: defaultValuesTemp,
      } = formatFilterConditions(res);
      setActionItemCategory(res?.action_item_category || []);
      setValues(valuesTmp);
      setConditions(conditionsTmp);
      setDefaultValues(defaultValuesTemp);
      return { values: valuesTmp, conditions: conditionsTmp };
    } catch (exception) {
    } finally {
      if (loading) {
        setLoading(false);
      }
    }
    return { values, conditions };
  };

  useEffect(() => {
    refreshConditions();
  }, []);

  return {
    loading,
    values,
    conditions,
    refreshConditions,
    defaultValues,
    actionItemCategory,
  };
}
